<template>
    <div
        class="pageBackground tooltipElement"
        :class="isActive && !pageSettingsActive ? 'active' : ''"
    >
        <div
            class="pageBackground_trigger"
            :class="isActive && !pageSettingsActive ? 'tooltipHide' : ''"
            @click="isActive = !isActive; $emit('update:bgImageOpen', isActive)"
        >
            <inline-svg
                :src="backgroundImage_icon"
                :fill="isActive ? `#${this.getSessionDetails.editorSetup.colors.primaryColor}` : '#707070'"
            />
        </div>
        <div class="pageBackground_container">
            <div
                class="pageBackground_options"
                :class="backgroundUrl !== null ? 'withBg' : ''"
            >
                <div class="pageBackground_size">
                    <strong>{{ $t('editorScenePageBackgroundSize') }}</strong>
                    <div class="pageBackground_size-options">
                        <div>
                            <input
                                v-for="option in backgroundSizeOptions"
                                :key="option.value"
                                @click="setBackgroundSize(false, option.value)"
                                :class="backgroundSize === option.value ? 'active' : ''"
                                :disabled="isPercent"
                                type="button"
                                :value="option.name"
                            />
                        </div>
                        <div
                            class="pageBackground_size_form-group"
                        >
                            <div>
                                <input
                                    id="isPercent"
                                    v-model="isPercent"
                                    type="checkbox"
                                    name="isPercent"
                                    @change="setBackgroundSize(isPercent, isPercent ? backgroundSizePercent : backgroundSize)"
                                />
                                <span>{{ $t('editorScenePageBackgroundCustomSize') }}</span>
                            </div>
                            <div>
                                <input
                                    id="backgroundSizePercent"
                                    v-model.number="backgroundSizePercent"
                                    type="number"
                                    name="backgroundSizePercent"
                                    min="0"
                                    @input="setBackgroundSize(true, backgroundSizePercent)"
                                    :disabled="!isPercent"
                                />
                                <span>%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pageBackground_position">
                    <strong>{{ $t('editorScenePageBackgroundPosition') }}</strong>
                    <div class="pageBackground_position-options">
                        <button
                            v-for="option in backgroundPositionOptions"
                            :key="option"
                            @click="setBackgroundPosition(option)"
                            :class="backgroundPosition === option ? 'active' : ''"
                        >
                            {{ option }}
                        </button>
                    </div>
                </div>
                <div class="pageBackground_repeat">
                    <strong>{{ $t('editorScenePageBackgroundRepeat') }}</strong>
                    <div class="pageBackground_position-options">
                        <button
                            v-for="option in backgroundRepeatOptions"
                            :key="option.value"
                            @click="setBackgroundRepeat(option.value)"
                            :class="backgroundRepeat === option.value ? 'active' : ''"
                        >
                            {{ option.name }}
                        </button>
                    </div>
                </div>
                <div
                    class="pageBackground_remove"
                >
                    <strong>{{ $t('editorScenePageBackgroundAdditional') }}</strong>
                    <div>
                        <div
                            @click="removeBackground"
                        >
                            {{ $t('editorScenePageBackgroundRemove') }}
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <Tooltip :tooltipText="`${ $t('editorScenePageBackgroundSettings') }`" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import backgroundImage_icon from '@/assets/icons/background.svg';
    import Tooltip from '@/components/Global/Tooltip.vue';

    export default {
        props: ['pageId', 'pageSettingsActive', 'bgImageActive'],
        data() {
            return {
                backgroundImage_icon,
                isActive: false,
                backgroundSizeOptions: [
                    {
                        name: 'Fill page',
                        value: 'cover'
                    },
                    {
                        name: 'Fit to page',
                        value: 'contain'
                    }
                ],
                backgroundPositionOptions: ['top', 'left', 'center', 'right', 'bottom'],
                backgroundRepeatOptions: [
                    {
                        name: 'Repeat',
                        value: 'repeat'
                    },
                    {
                        name: 'Only Horizontally',
                        value: 'repeat-x'
                    },
                    {
                        name: 'Only Vertically',
                        value: 'repeat-y'
                    },
                    {
                        name: 'No repeat',
                        value: 'no-repeat'
                    }
                ],
                isPercent: false,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundSizePercent: 100,
                backgroundRepeat: 'no-repeat',
                backgroundUrl: null
            }
        },
        methods: {
            setBackgroundSize(isPercent, value) {
                if (isPercent) {
                    this.backgroundSize = 'cover';
                    this.$store.dispatch('SET_PAGE_BACKGROUND', {
                        ...this.getPages.find(page => page.content.id === this.pageId).content.backgroundImage,
                        backgroundSize: `${value}%`
                    });
                } else {
                    this.backgroundSize = value;
                    this.$store.dispatch('SET_PAGE_BACKGROUND', {
                        ...this.getPages.find(page => page.content.id === this.pageId).content.backgroundImage,
                        backgroundSize: value
                    });
                }
            },
            setBackgroundPosition(value) {
                this.backgroundPosition = value;
                this.$store.dispatch('SET_PAGE_BACKGROUND', {
                    ...this.getPages.find(page => page.content.id === this.pageId).content.backgroundImage,
                    backgroundPosition: value
                });
            },
            setBackgroundRepeat(value) {
                this.backgroundRepeat = value;
                this.$store.dispatch('SET_PAGE_BACKGROUND', {
                    ...this.getPages.find(page => page.content.id === this.pageId).content.backgroundImage,
                    backgroundRepeat: value
                });
            },
            removeBackground() {
                this.isPercent = false;
                this.backgroundSize = 'cover';
                this.backgroundPosition = 'center';
                this.backgroundRepeat = 'no-repeat';
                this.backgroundUrl = null;
                // this.$store.dispatch('REMOVE_PAGE_BACKGROUND');
                this.$store.dispatch('SET_PAGE_BACKGROUND', {
                    url: null,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                });
            }
        },
        watch: {
            'getPages': {
                deep: true,
                handler() {
                    const pageBackgroundImage = this.getPages.find(page => page.content.id === this.pageId).content.backgroundImage;
                    const regEx = /%/;

                    if (regEx.test(pageBackgroundImage.backgroundSize)) {
                        this.backgroundSizePercent = pageBackgroundImage.backgroundSize.replace(regEx, '');
                    } else {
                        this.backgroundSize = pageBackgroundImage.backgroundSize;
                    }
                   
                    this.backgroundPosition = pageBackgroundImage.backgroundPosition;
                    this.backgroundRepeat = pageBackgroundImage.backgroundRepeat;
                    this.backgroundUrl = pageBackgroundImage.url;
                }
            },
            'bgImageActive': {
                deep: true,
                handler() {
                    this.isActive = this.bgImageActive;
                }
            }
        },
        computed: {
            ...mapGetters([
                'getSessionDetails',
                'getPages'
            ])
        },
        created() {
            const pageBackgroundImage = this.getPages.find(page => page.content.id === this.pageId).content.backgroundImage;
            const regEx = /%/;

            if (regEx.test(pageBackgroundImage.backgroundSize)) {
                this.isPercent = true;
                this.backgroundSizePercent = pageBackgroundImage.backgroundSize.replace(regEx, '');
            } else {
                this.isPercent = false;
                this.backgroundSize = pageBackgroundImage.backgroundSize;
            }
            
            this.backgroundPosition = pageBackgroundImage.backgroundPosition;
            this.backgroundRepeat = pageBackgroundImage.backgroundRepeat;
            this.backgroundUrl = pageBackgroundImage.url;
        },
        components: {
            Tooltip
        }
    }
</script>

<style lang="scss" scoped>
    .pageBackground {
        position: relative;

        &_remove {
            > div {
                > div {
                    border-right: 1px solid #707070;
                    display: inline-block;
                    padding: 5px 10px 5px 0;
                    cursor: pointer;
                }
            }
        }

        .pageBackground_trigger {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px;
            margin: 0 5px;
        }

        .pageBackground_container {
            display: none;
            padding: 15px 15px 5px 15px;
            background-color: #f5f5f5;
            box-shadow: 2px 3px 2px 0px #b7b7b7;
            position: absolute;
            width: 355px;
            top: 22px;
            left: 5px;
            color: #707070;
            font-size: 12px;
            z-index: 100;
        }

        &.active {
            .pageBackground_trigger {
                background-color: #f5f5f5;
                box-shadow: 2px 0px 4px 0px #b7b7b7;
            }
            .pageBackground_container {
                display: block;
            }
        }
        &:hover {
            svg {
                fill: var(--primary-color);
            }
        }

        &_url {
            word-break: break-all;
        }

        &_options {
            opacity: 0.6;
            pointer-events: none;
            cursor: not-allowed;

            &.withBg {
                opacity: 1;
                pointer-events: all;
                cursor: unset;
            }

            > div {
                margin-bottom: 20px;

                > strong {
                    margin-bottom: 10px;
                    display: block;
                }

                > div {
                    border-left: 1px solid #707070;
                    padding-left: 5px;
                }
            }
        }

        &_position {

            &-options {
                button {
                    text-align: center;
                    font-size: 12px;
                    border: unset;
                    color: #707070;
                    background-color: transparent;
                    border-right: 1px solid #707070;
                    padding: 5px 10px 5px 0;
                    margin-right: 10px;
                    text-transform: capitalize;
                    cursor: pointer;

                    &:hover,
                    &.active {
                        color: var(--primary-color);
                    }
                }
            }
        }

        &_size {

            &-options {
                display: flex;
                align-items: center;

                > div {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
            }
            input[type="button"] {
                text-align: center;
                font-size: 12px;
                border: unset;
                color: #707070;
                background-color: transparent;
                border-right: 1px solid #707070;
                padding: 5px 10px 5px 0;
                margin-right: 10px;
                cursor: pointer;

                &:hover,
                &.active {
                    color: var(--primary-color);
                }

                &:disabled {
                    color: #707070;
                }
            }

            

            &_form-group {
                

                > div:nth-of-type(1) {
                    display: flex;
                    align-items: center;

                    input {
                        margin-right: 5px;
                    }
                }
                > div:nth-of-type(2) {
                    width: 50%;

                    input {
                        width: 60%;
                        margin-right: 5px;
                        padding: 4px;
                        border: unset;
                    }
                }
            }
        }
    }
</style>